import PropTypes from 'prop-types';
import { css, etiColors } from '@eti/styles';
import { Icon as EtiIcon } from '@eti/components';
import { CheckedBaggage } from '@eti/types';
import { CABIN_BAGGAGE, CHECK_IN_BAGGAGE } from '@eti/products';
import IncludedBaggageSummary, { baggageIconStyles } from './IncludedBaggageSummary';

const productStyles = css`
  align-items: center;
  color: ${etiColors.grayScale[10]};
  display: flex;
  font-size: 0.75rem;
  margin-left: 1.65rem;
  margin-top: 0.25rem;

  [dir='rtl'] & {
    margin-left: 0;
    margin-right: 1.65rem;
  }
`;

// TODO: AN-2779 add support for an Icon placeholder for {Icon} in `@eti/components`
const iconWrapperStyles = css`
  height: 12px;
  width: 22px;
`;
const ProductItem = ({ product = [], baggageDetails, baggageStatus, secondBaggageDetails }) => {
  switch (product.id) {
    case String(CABIN_BAGGAGE.id):
      // TODO: AN-2781 use cabinBaggageSummary instead when it's implemented in backend
      return (
        <div className={productStyles}>
          <div className={iconWrapperStyles}>
            <EtiIcon
              className={baggageIconStyles}
              color={etiColors.grayScale[8]}
              id="cabin-baggage"
              size="12px"
            />
          </div>
          {product.quantity} {product.name}
        </div>
      );
    case String(CHECK_IN_BAGGAGE.id):
    default:
      return (
        <div className={productStyles}>
          <IncludedBaggageSummary
            baggageDetails={baggageDetails}
            baggageStatus={baggageStatus}
            secondBaggageDetails={secondBaggageDetails}
          />
        </div>
      );
  }
};

ProductItem.propTypes = {
  baggageDetails: CheckedBaggage,

  baggageStatus: PropTypes.string,
  product: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    quantity: PropTypes.number,
  }),
  secondBaggageDetails: PropTypes.shape({
    __typename: PropTypes.string,
    pieces: PropTypes.any,
    weight: PropTypes.number,
    weightUnit: PropTypes.string,
  }),
};

export default ProductItem;
